import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  lang = this.translate.getBrowserLang();
  private sub?: Subscription;

  constructor(private translate: TranslateService, private languageService: LanguageService) {
    translate.addLangs(['en', 'nl']);
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.sub = this.languageService.language$.subscribe(language => {
      console.log('Language changed to', language);
      this.lang = language;
      this.translate.use(language);
    });
  }

  switchLanguage(language: string) {
    console.log(language);
    this.languageService.setLanguage(language);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
